import { createAction, props } from '@ngrx/store';
import { AdminCatalogModel } from 'src/app/model/admin/catalog';
import { BaseModalModel } from 'src/app/model/core/base-modal';

const adminCatalogLabels = {
  ADD_RESULT: 'ADMIN_CATALOG_ADD_RESULT',
  ADD_SUB_CATALOG: 'ADMIN_CATALOG_ADD_SUB_CATALOG',
  PUT_SUB_CATALOG: 'ADMIN_CATALOG_PUT_SUB_CATALOG',
  PATCH_SUB_CATALOG: 'ADMIN_CATALOG_PATCH_SUB_CATALOG',
  SET_SUB_CATALOG: 'ADMIN_CATALOG_SET_SUB_CATALOG',
  SET_SUB_CATALOG_DEFAULT: 'ADMIN_CATALOG_SET_SUB_CATALOG_DEFAULT',
  SET_ALL_DEFAULT: 'ADMIN_CATALOG_SET_ALL_DEFAULT',
};

export const adminCatalogActions = {
  addResultAction: createAction(
    adminCatalogLabels.ADD_RESULT,
    props<{ result: AdminCatalogModel[] }>()
  ),
  addSubCatalogAction: createAction(
    adminCatalogLabels.ADD_SUB_CATALOG,
    props<{ code: string; value: AdminCatalogModel[] }>()
  ),
  putSubCatalogAction: createAction(
    adminCatalogLabels.PUT_SUB_CATALOG,
    props<{ code: string; value: AdminCatalogModel }>()
  ),
  patchSubCatalogAction: createAction(
    adminCatalogLabels.PATCH_SUB_CATALOG,
    props<{ code: string; value: AdminCatalogModel }>()
  ),
  setSubCatalogAction: createAction(
    adminCatalogLabels.SET_SUB_CATALOG,
    props<BaseModalModel<AdminCatalogModel>>()
  ),
  setSubCatalogDefaultAction: createAction(
    adminCatalogLabels.SET_SUB_CATALOG_DEFAULT,
    props<any>()
  ),
  setAllDefaultAction: createAction(
    adminCatalogLabels.SET_ALL_DEFAULT,
    props<any>()
  ),
};
